import React, { useState } from "react";

export default function LoginScreen({ onSubmit, loading, error }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) return;
    onSubmit({ email: email.trim(), password });
  };

  const inputStyle = {
    width: "100%", boxSizing: "border-box",
    padding: "9px 12px", borderRadius: 8, fontSize: 13,
    border: "1px solid var(--field-border)",
    background: "var(--field-bg)", color: "var(--text-primary)",
    outline: "none",
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--page-gradient)", fontFamily: "Arial, sans-serif",
    }}>
      <div style={{
        width: 300, padding: "28px 22px",
        borderRadius: 14,
        background: "var(--surface-soft)",
        border: "1px solid rgba(148,163,184,0.15)",
        boxShadow: "0 16px 48px rgba(0,0,0,0.35)",
        color: "var(--text-primary)",
      }}>

        {/* Brand */}
        <div style={{ textAlign: "center", marginBottom: 26 }}>
          <div style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 54, height: 54, borderRadius: 14, marginBottom: 12,
            background: "linear-gradient(135deg, var(--accent-primary) 0%, #0891b2 100%)",
            fontSize: 24,
          }}>
            📊
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: -0.3 }}>costy.pro</div>
          <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 3 }}>
            სამშენებლო ბიუჯეტის სისტემა
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "var(--text-muted)", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>
            ელ. ფოსტა
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com"
            disabled={loading}
            autoFocus
            style={{ ...inputStyle, marginBottom: 14 }}
          />

          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "var(--text-muted)", marginBottom: 5, textTransform: "uppercase", letterSpacing: 0.5 }}>
            პაროლი
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            disabled={loading}
            style={{ ...inputStyle, marginBottom: 18 }}
          />

          {error && (
            <div style={{
              background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.3)",
              borderRadius: 6, padding: "8px 10px", color: "#f87171",
              marginBottom: 14, fontSize: 12, lineHeight: 1.4,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !email || !password}
            style={{
              width: "100%", padding: "10px", borderRadius: 8,
              border: "none", background: "var(--accent-primary)", color: "#fff",
              fontWeight: 600, fontSize: 14,
              cursor: loading || !email || !password ? "not-allowed" : "pointer",
              opacity: loading || !email || !password ? 0.55 : 1,
              transition: "opacity 0.15s",
            }}
          >
            {loading ? "მიმდინარეობს..." : "შესვლა"}
          </button>
        </form>

        <div style={{ marginTop: 18, fontSize: 11, color: "var(--text-muted)", textAlign: "center" }}>
          costy.pro · boq.ge
        </div>
      </div>
    </div>
  );
}
